export default "__VITE_ASSET__x8V$CzgX__"